import React, { useState } from "react";
import { cls } from "@wss/cls";
import { range } from "range";
import getMinBuyForQuantityDropdown from "../Pricing/AddToCart/getMinBuyForQuantityDropdown";
interface Props {
  minBuy: number;
  mustBuy: number;
  useSingleItemStyle: boolean;
  extraQuantityContainerClassName?: string;
  handleQuantityChange: (event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => void;
}
const CarouselQuantityDropdown = ({
  minBuy,
  mustBuy,
  useSingleItemStyle,
  handleQuantityChange,
  extraQuantityContainerClassName = ""
}: Props) => {
  const [quantityChanged, setQuantityChanged] = useState(false);
  const numberOfOptions = 15;
  const startQuantity = getMinBuyForQuantityDropdown({
    minBuy,
    mustBuy
  });
  const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setQuantityChanged(true);
    handleQuantityChange(event);
  };
  return <div className={cls("form__group", "qty_dropdown", extraQuantityContainerClassName)} data-sentry-component="CarouselQuantityDropdown" data-sentry-source-file="CarouselQuantityDropdown.tsx">
      <div className={`form__control-container${quantityChanged ? "" : " no-selection"}`}>
        <select name="qty" className="configure qty-preset-select form__control max-h-8" onChange={handleOnChange} defaultValue="0" data-testid="quantity-dropdown" style={quantityChanged ? {
        padding: "7px 10px 6px"
      } : {}}>
          {range(0, numberOfOptions).map(index => <option key={index}>{startQuantity + index * mustBuy}</option>)}
          <option value="other">Other</option>
        </select>
        {!useSingleItemStyle && <i className="icon-down-micro form__control-icon form__control-icon--lg" />}
      </div>
    </div>;
};
export default CarouselQuantityDropdown;